import React, { useEffect, useState } from 'react';
import AudienceData from './AudienceData';
import { IAudienceDataModal } from '../../../dto/IAudienceDataModal';
import { Box, Tab } from '@mui/material';
import { BookingService } from '../../../../service';
import { ErrorToast } from '../../../../../../../../utils/toasters';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { IAudienceCharts } from '../../../dto/IAudienceCharts';
import { getFilteredChartsData } from '../../../../../../../../shared/functions/Functions';
import { AudienceCharts } from './AudienceCharts';
import AudienceKpiScreenshots from './AudienceKpiScreenshots';
import { User } from '../../../../../../../../model/user/User';
import CardLayout from '../../../../../../../../shared/components/card/CardLayout';

export const chartColors = ['#05BBC9', '#952CB7', '#FC9D79', '#e2051c', '#0fda65', '#197ee1', '#181c32'];

interface IEnhancedAudienceDataProps {
    user?: User;
    activeTabModal: string;
    userId?: number;
}
const EnhancedAudienceData = ({ userId, user, activeTabModal }: IEnhancedAudienceDataProps) => {
    const [audienceData, setAudienceData] = useState<IAudienceDataModal>();
    const [allCharts, setAllCharts] = useState<IAudienceCharts>({
        engagementChart: [],
        followersChart: [],
        followingChart: [],
        likesChart: [],
    });

    const [value, setValue] = useState('0');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (activeTabModal === '2') {
            BookingService.getAudienceDataModal(userId)
                .then(response => {
                    setAudienceData(response);
                    setAllCharts(getFilteredChartsData(response.chartData));
                })
                .catch(err => ErrorToast(err));
        }
    }, [userId]);

    return (
        <Box>
            <CardLayout classCard="mb-4">
                <TabContext value={value}>
                    <TabList onChange={handleChange}>
                        {audienceData?.platformDataArray.map((platformData, index) => {
                            return (
                                <Tab key={index} label={`${platformData?.mainPlatform?.name}`} value={String(index)} />
                            );
                        })}
                    </TabList>
                    {audienceData?.platformDataArray.map((platformData, index) => {
                        return (
                            <TabPanel key={index} value={String(index)}>
                                <AudienceData audienceData={platformData} />
                            </TabPanel>
                        );
                    })}
                </TabContext>
            </CardLayout>
            {!!user?.userKpiScreenshots?.length && <AudienceKpiScreenshots user={user} />}
            <AudienceCharts charts={allCharts} chartDates={audienceData?.chartDates ?? []} />
        </Box>
    );
};

export default EnhancedAudienceData;
